import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=58a8e0d2"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports